import React, { Component } from 'react';
import {array, func, string} from 'prop-types';

import { ShowCase, Preview, Controls } from '@components/ShowCase';

export default class InputShowcase extends Component {

  static propTypes = {
    component: func.isRequired,
    optionsGroup: array,
    backgrounds: array,
    codeTemplate: string,
  };

  render() {
    const { component, optionsGroup, backgrounds, codeTemplate } = this.props;

    return (
      <ShowCase codeTemplate={codeTemplate}>
        <Preview>
          {(componentProps) => (
            component(componentProps)
          )}
        </Preview>
        <Controls optionsGroup={optionsGroup} backgrounds={backgrounds} />
      </ShowCase>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/elements/Inputs/InputShowcase.js